import React from 'react'
import PropTypes from 'prop-types'
import { Translate } from 'i18n'
import './style.css'


const ItemsEmpty = ({ isArrowVisible, closeWidget }) => {
    const closeList = () => {
        closeWidget()
    }

    return (
        <div className='items-empty-list'>
            { isArrowVisible && <div className='empty-list-arrow'></div> }
            <div className='empty-list-message'>
                <div className='empty-list-message__head'><Translate value='yourShoppingListIsEmpty' /></div>
                <div className='empty-list-message__text'><Translate value='startAddingItemsByClickingOnTheFieldAbove' /></div>
                <div className='empty-list-controls'>
                    <button
                        onClick={() => closeList()}
                        className='button button_type_secondary button_bold'>
                        <Translate value='maybeLater' />
                    </button>
                </div>
            </div>
        </div>
    )
}

ItemsEmpty.propTypes = {
    isArrowVisible: PropTypes.bool.isRequired,
    closeWidget: PropTypes.func.isRequired
}

export default ItemsEmpty
